// extracted by mini-css-extract-plugin
module.exports = {"nav-bottom":"nav-bottom_nav-bottom__rI1xP","active":"nav-bottom_active__Zpxi9","icon-container":"nav-bottom_icon-container__MPVgc"};